(() => {
  if (window.O2CartAttributes) return;

  let pending = Promise.resolve();
  const desiredAttributes = {};

  const persist = async (options = {}) => {
    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      ...options,
      body: JSON.stringify({ attributes: desiredAttributes }),
    });
    if (!response.ok) {
      throw new Error(`Unable to persist cart attributes (${response.status}).`);
    }
    return response.json();
  };

  window.O2CartAttributes = {
    update(attributes, { immediate = false, keepalive = false } = {}) {
      Object.assign(desiredAttributes, attributes);
      const request = immediate ? persist({ keepalive }) : pending.then(() => persist());

      // Keep later writers queued even after a failure; the caller still receives the rejection.
      const settled = request.then(() => undefined, () => undefined);
      pending = immediate ? Promise.all([pending, settled]).then(() => undefined) : settled;
      return request;
    },
  };
})();
